export default class SmallMessage extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <div className="message">
        <div className={`message__icon message__icon-${this.props.type}`}></div>
        <p className="message__text">
          {this.props.message}
        </p>
      </div>
    )
  }
}
